<template>
  <div>
    <el-dialog
      width="460px"
      center
      title="支付"
      :visible.sync="visible"
      @closed="onClose"
    >
      <div class="payInner">
        <ul class="choosePayStyle">
          <li
            v-for="item in PayStyleOpt"
            v-show="chooseStyle == item.key"
            @click="choosePayStyle(item)"
            :key="item.key"
            :class="{ active: chooseStyle == item.key }"
          >
            <i
              class="iconfont"
              :class="{
                aliPayColor: item.key == 'alipay',
                weChatColor: item.key == 'wechat',
                moneyBagColor: item.key == 'moneyBag',
              }"
              v-html="item.icon"
            >
            </i>
            <span>{{ item.label }}</span>
          </li>
        </ul>
        <!-- 选择支付宝/微信 -->
        <div class="code" v-if="chooseStyle != 'moneyBag'" key="NOmoneyBag">
          <!-- 微信支付二维码 -->
          <div ref="qrcode" id="qrcode" v-if="chooseStyle == 'wechat'"></div>
          <!-- 支付宝支付二维码 -->
          <iframe 
              v-if="chooseStyle == 'alipay'"
              :srcdoc="payAliQRcode" 
              frameborder="no" 
              border="0"
              marginwidth="0"
              marginheight="0"
              scrolling="no" 
              width="100" 
              height="100"
              style="overflow: hidden;"
              sandbox="allow-scripts allow-top-navigation allow-same-origin allow-forms"
              >
          </iframe>
        </div>

        <!-- 选择钱包 -->
        <div class="moneyBag" key="moneyBag" v-else>
          <ul class="baseUl">
            <li>
              <span> 当前余额（元）：</span>
              <span class="price"> 1000 </span>
            </li>
            <li>
              <span> 需支付（元）：</span>
              <span class="price"> 198 </span>
            </li>
          </ul>
          <div class="btnWrap">
            <el-button type="primary">支付</el-button>
          </div>
        </div>
        <!-- 提示 -->
        <div class="tips">支付完成之时起5分钟内生效</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { paymentRepetition } from "@/api/EvidenceService";
export default {
  name: "",

  data() {
    return {
      // 弹框是否显示
      visible: false,
      chooseStyle: "wechat",
      orderInfo: null,
      orderStatus: "10",
      checkStatusId: -1,
      paymentRequest: null,
      PayStyleOpt: [
        {
          key: "alipay",
          label: "支付宝支付",
          icon: "&#xe634;",
        },
        {
          key: "wechat",
          label: "微信支付",
          icon: "&#xe633;",
        },
        // {
        //   key: "moneyBag",
        //   label: "余额支付",
        //   icon: "&#xe632; ",
        // },
      ],
      payAliQRcode: '',
    };
  },
  created() {
    // this.visible = true
    this.init();
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    let that = this;
    if (that.checkStatusId != -1) {
      clearInterval(that.checkStatusId);
      that.checkStatusId = -1;
    }
  },
  methods: {
    init() {
      console.log("init pay..");
    },
    choosePayStyle(item) {
      this.chooseStyle = item.key;

    },
    // 关闭弹框时触发的事件
    onClose() {
      document.getElementById("qrcode").innerHTML = "";
      this.$emit("close", this.orderStatus == "21");
    },
    checkOrderStatus() {
      let that = this;
      if (that.checkStatusId != -1) {
        clearInterval(that.checkStatusId);
      }
      let checkStatus = () => {
        paymentRepetition(that.orderInfo.paymentOrderNo).then(({ data }) => {
          if (data.paymentStatus == "21") {
            //已支付
            clearInterval(that.checkStatusId);
            that.orderStatus = "21";
            that.visible = false;
          }
        });
      };

      that.checkStatusId = setInterval(checkStatus, 5000);
    },
    showDialog(orderInfo) {
      this.orderInfo = orderInfo;
      this.chooseStyle = orderInfo.paymode;
      this.paymentRequest = orderInfo.paymentRequest;
      this.visible = true;
      if (orderInfo.paymode == "wechat") {  //微信支付
        setTimeout(() => {
          // console.log("hello..");
          console.log('微信支付二维码：',this.paymentRequest.payResponse.code_url);
          var qrcode = new QRCode("qrcode", {
            text: this.paymentRequest.payResponse.code_url, // 需要转换为二维码的内容
            width: 100,
            height: 100,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
        }, 400);

        this.checkOrderStatus();
      }else if (orderInfo.paymode == "alipay") {  //支付宝支付
        this.checkOrderStatus();
        // console.log(this.paymentRequest);
        setTimeout(() => {
          // console.log('支付宝支付orderString：',this.paymentRequest.payResponse.form);
          // var qrcode = new QRCode("qrcode", {
          //   text: this.paymentRequest.payResponse.orderString, // 需要转换为二维码的内容
          //   width: 100,
          //   height: 100,
          //   colorDark: "#000000",
          //   colorLight: "#ffffff",
          //   correctLevel: QRCode.CorrectLevel.H,
          // });
          let payResponseForm = this.paymentRequest.payResponse.form;
          // payResponseForm = payResponseForm.replace(/[\\]/g,'')   //去掉反斜杠
          // console.log('支付宝的二维码生成用payResponseForm::::::::::::::::',payResponseForm);
          this.payAliQRcode = payResponseForm;    // 支付宝的二维码生成用 iframe 标签
          // this.timer = setInterval(() => {    // 通过定时器每间隔一会去请求查询支付宝支付状态（具体参数根据项目需要而定）
          //     this.handleQueryAliPayStatus(row, res.data.outTradeNo);
          // }, 1000);

        },400)
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.payInner {
  color: rgba(0, 18, 22, 0.65);
  font-size: 16px;
  padding-bottom: 16px;
  /deep/ .el-dialog__header .el-dialog__title {
    font-size: 24px;
  }
  .choosePayStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    .iconfont {
      font-size: 32px;
      margin-right: 4px;
      line-height: 1em;
    }
    li {
      display: flex;
      margin: 0 8px;
      align-items: center;
      border: solid 1px rgba(0, 18, 22, 0.2);
      border-radius: 2px;
      padding: 2px 8px;
    }
    li.active {
      color: #007DFF;
      border-color: #007DFF;
    }
  }
  .price {
    color: rgba(0, 18, 22, 0.85);
    font-weight: bold;
    font-size: 20px;
  }
  .moneyBag {
    padding: 48px 48px 0;
  }
  .btnWrap {
    margin: 32px 0 16px;
    .el-button--primary {
      width: 100%;
    }
  }
  .tips {
    text-align: center;
  }
  .code {
    display: flex;
    justify-content: center;
    margin: 36px 0 24px;
    img {
      width: 144px;
    }
  }
}
</style>
